import { z } from 'zod';

export const providerValidationSchema = z.object({
  bookings: z.array(
    z.object({
      id: z.string(),
      status_by_provider: z.boolean(),
    })
  ),
  comment: z.string().optional(),
  files: z.array(z.string().url()).optional(),
});

export const repValidationSchema = z.object({
  bookings: z.array(
    z.object({
      id: z.string(),
      status_by_rep: z.boolean(),
    })
  ),
  comment: z.string().optional(),
});
